/* eslint-disable prettier/prettier */
if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.card = this.closest('.card')
      this.slider = this.closest('.slider')
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) cartNotification.setActiveElement(this.opener);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.opener = null;
      this.classList.remove('is-open')
      this.card.classList.remove('is-open')
      this.opener.classList.remove('is-open')
      const hasOpenModals = document.querySelector('.quick-add-modal.is-open')
      if (!hasOpenModals) {
        document.removeEventListener('scroll', this.onDocumentScroll.bind(this))
      }
      if (this.slider && !hasOpenModals) {
        this.slider.removeEventListener('scroll', this.onScrollSlider.bind(this))
      }
      this.style.top = null
      this.style.left = null
      this.style.width = null
      this.style.minHeight = null
      this.style.overflow = null
      super.hide();
    }

    hideAllOpen() {
      const openQuickAdds = document.querySelectorAll('quick-add-modal.is-open')
      const otherQuickAdds = Array.from(openQuickAdds).filter(
        function(quickAdd) {
          return quickAdd !== this
        }.bind(this)
      )
      otherQuickAdds.forEach(quickAdd => quickAdd.hide())
    }

    positionQuickAdd() {
      const cartDrawer = this.closest('.cart-drawer')
      const {
        left, bottom, width, height
      } = this.card.getBoundingClientRect()
      let posTop =  bottom
      let posLeft = left
      if (cartDrawer) {
        posTop += cartDrawer.scrollTop
        posTop = `calc(${posTop}px - var(--header-bottom-position))`
        posLeft -= cartDrawer.getBoundingClientRect().left
      } else {
        posTop = `${posTop}px`
      }
      this.style.top =  `${posTop}`
      this.style.left =  `${posLeft}px`
      this.style.width =  `${width}px`
      this.style.minHeight =  `${height}px`
    }

    onScrollSlider() {
      this.positionQuickAdd()
    }

    onDocumentScroll(){
      this.positionQuickAdd()
    }

    createQuickAddForm() {
      const { formId, selectorUrl } = this.card.dataset;
      const sectionId = this.productElement.dataset.section;
      const quickAddForm = document.createElement("div")
      quickAddForm.classList.add('quick-add-product-form')
      this.variantSelectors.dataset.selectorUrl = selectorUrl
      quickAddForm.appendChild(this.variantSelectors)
      quickAddForm.appendChild(this.productForm)
      quickAddForm.innerHTML = quickAddForm.innerHTML.replaceAll(sectionId, formId);
      quickAddForm.querySelectorAll('variant-selects, variant-radios,product-selects, product-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId
      });
      return quickAddForm
    }

    setVariantSelectors() {
      if (this.variantSelectors) {
        this.variantSelectors.setAttribute('data-update-url', 'false');
      }
    }

    show(opener) {
      this.opener = opener;
      this.setAttribute('open', '');
      window.pauseAllMedia();
      opener.setAttribute('aria-disabled', true);
      if (this.card) {
        this.card.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
      }
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.variantSelector = this.productElement.querySelector('[id^="VariantSelectors-"]');
          if (this.variantSelector) {
            this.variantSelectors =  this.variantSelector.querySelector('variant-radios,variant-selects,product-radios,product-selects');
          }


          this.productForm = this.productElement.querySelector('product-form')
          if (this.productForm) {
            const quickAddForm = this.createQuickAddForm()
            this.positionQuickAdd()
            document.body.classList.remove('overflow-hidden');
            document.addEventListener('scroll', this.onDocumentScroll.bind(this))
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, quickAddForm);
            this.setVariantSelectors()
          }

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          this.removeGalleryListSemantic();

          this.classList.add('is-open')
          this.card.classList.add('is-open')
          opener.classList.add('is-open')
          
          this.card.querySelector(`.product-preorder-modal`).classList.add('hidden');

          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (this.slider) {
            this.slider.addEventListener('scroll', this.onScrollSlider.bind(this))
          }
          this.hideAllOpen()
        });

    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      const cardFooter = this.card.querySelector('.card__footer')
      const cardContent = this.card.querySelector('.card__content')
      if (cardFooter) {
        cardFooter.appendChild(this);
      } else {
        cardContent.appendChild(this);
      }
    }

    setInnerHTML(element, html) {
      const currentChildForm = element.querySelector('.quick-add-product-form')
      if (currentChildForm) {
        currentChildForm.innerHTML = html.innerHTML
      } else {
        element.appendChild(html);
      }

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });


    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const galleryList = this.productElement.querySelector('[id^="Slider-Gallery"]');
      if (galleryList) galleryList.remove();


      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }


    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }
  });
}
